export const authorizedWS = (token) => {
  // Remove any trailing slash from server URL
  const serverUrl = process.env.REACT_APP_SERVER_URL.replace(/\/$/, '');

  const wsUrl = `${serverUrl.replace(/^http:/, "ws:").replace(
    /^https:/,
    "wss:"
  )}/ws?token=${token}`;

  console.log("🔍 [authorizedWS] Creating WebSocket with URL:", wsUrl);

  return new WebSocket(wsUrl);
};
